import { Button } from "./ui/button";
import { motion } from "framer-motion";
import { QuoteModal } from "./QuoteModal";
import { Star, ShieldCheck, Clock, Phone } from "lucide-react";

const Hero = () => {
  return (
    <section className="relative w-full min-h-[85vh] flex items-center bg-gradient-to-br from-neutral-900 to-neutral-800 xl:bg-none overflow-hidden">
      {/* Desktop Background Image with Scrim */}
      <div 
        className="hidden xl:block absolute inset-0 bg-cover bg-top bg-no-repeat"
        style={{ backgroundImage: 'url("https://images.leadconnectorhq.com/image/f_webp/q_80/r_1600/u_https://assets.cdn.filesafe.space/Zrqvy6cNzSbnzDV55cv1/media/6936df934b202f6855b43c43.jpg")' }}
      >
        <div className="absolute inset-0 bg-black/70"></div>
      </div>

      <div className="container relative z-10 mx-auto px-4 md:px-6 pt-32 md:pt-40 pb-16">
        <motion.div 
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          className="max-w-4xl text-white"
        >
          <span className="inline-block font-bold tracking-wider text-primary mb-4 uppercase text-sm md:text-base bg-white/10 px-4 py-1.5 rounded-full backdrop-blur-sm">
            Ihr Profi Umzugsservice in Augsburg

          </span>
          
          <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl leading-[1.1] mb-6">
            Stressfrei umziehen inkl. <br className="hidden md:block" />
            Tragen, Transport & Montage
          </h1>
          
          <p className="text-lg md:text-xl text-neutral-200 mb-10 max-w-2xl font-medium">
            Lehnen Sie sich entspannt zurück. Wir übernehmen Ihren kompletten Umzug, die fachgerechte Möbelmontage und alle Handwerksarbeiten – zuverlässig, schnell und voll versichert.
          </p>
          
          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2, ease: "easeOut" }}
            className="flex flex-col sm:flex-row items-start sm:items-center gap-4 mb-8"
          >
            <QuoteModal>
              <Button size="lg" className="w-full sm:w-auto">
                Kostenloses Angebot anfordern
              </Button>
            </QuoteModal>
            <Button size="lg" variant="secondary" asChild className="w-full sm:w-auto">
              <a href="tel:+4915888640762">
                <Phone className="w-5 h-5 mr-2" />
                +49 15888 640762
              </a>
            </Button>
          </motion.div>
          
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4, ease: "easeOut" }}
            className="flex flex-wrap items-center gap-6 text-sm md:text-base text-neutral-200"
          >
            <a href="https://share.google/xw8JE3IKl3tC9Kcw0" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 bg-white/10 hover:bg-white/20 transition-colors px-4 py-2 rounded-lg backdrop-blur-sm border border-white/10">
              <img src="https://storage.googleapis.com/revex-reputation-production/assets/google-icon.svg" alt="Google" width="24" height="24" loading="lazy" decoding="async" className="w-6 h-6" />
              <div>
                <div className="flex text-yellow-400 gap-0.5">
                  {[...Array(5)].map((_, i) => (
                    <Star key={i} className="w-4 h-4 fill-current" />
                  ))}
                </div>
                <div className="text-xs font-medium text-white mt-0.5">5.0 / 5.0 (60+ Bewertungen)</div>
              </div>
            </a>
            <div className="flex items-center gap-2">
              <ShieldCheck className="w-5 h-5 text-primary" />
              <span className="font-medium">Voll versichert</span>
            </div>
            <div className="flex items-center gap-2">
              <Clock className="w-5 h-5 text-primary" />
              <span className="font-medium">Schnell & Zuverlässig</span>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;